const VPFMetric = {
  displayName: 'Playback Error',
  short: 'Playback Error',
};

const VSFMetric = {
  displayName: 'Startup Error',
  short: 'Startup Error',
};

export const metricMetaOvbOverrides = {
  VideoStartFailuresTech: VSFMetric,
  VideoStartFailuresTechPercentage: VSFMetric,
  VideoPlaybackFailuresTech: VPFMetric,
  VideoPlaybackFailuresTechPercentage: VPFMetric,
  VideoPlaybackFailuresTechPercentageWithAds: VPFMetric,
  VideoPlaybackFailuresTechPercentageWithoutAds: VPFMetric,
};
